import { Button, Typography, styled } from '@mui/material';

export const HeaderW = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
`;

export const HeaderLeft = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderAuthorInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const HeaderAuthorName = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const HeaderDateTime = styled(Typography)`
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p030};
`;

export const DeleteButtonW = styled(Button)`
  height: 48px;
  padding: 0 24px;
  background-color: ${({ theme }) => theme.palette.white.main};
  color: ${({ theme }) => theme.palette.primary.main};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
  flex-shrink: 0;

  &:hover {
    background-color: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.white.light};
  }

  @media (max-width: 1023px) {
    height: 40px;
    padding: 0 16px;
    font-size: 12px;
  }
`;
